import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import { PropsWithClassName } from '@/types/common';
import * as styles from './StackableCard.module.scss';

type Props = PropsWithClassName<{
  title: ReactNode;
  body: ReactNode;
  image: ReactNode;
  index: number;
}>;

const StackableCard: FC<Props> = ({ title, body, image, className, index }) => (
  <div
    className={cx(styles.main, className)}
    style={
      {
        '--stackable-card-index': index,
      } as React.CSSProperties
    }
  >
    <div className={styles.content}>
      <div className={styles.body}>
        <h3 className={styles.title}>{title}</h3>
        {body}
      </div>
      <div className={styles.image}>{image}</div>
    </div>
  </div>
);

export default StackableCard;
